export const TESTING_AUTH_INFO_STORAGE_KEY = 'testing_auth_info';
export const E2E_TEST_SUBJECT = 'e2e test user';
